// Scopes used by Google methods and realtime services. Keep this list aligned with provider API calls.
// Source: https://developers.google.com/identity/protocols/oauth2/scopes
export const GOOGLE_OAUTH_SCOPE_GROUPS = [
  {
    label: 'Identity',
    sourceUrl: 'https://developers.google.com/identity/protocols/oauth2/scopes#openid-connect',
    scopes: ['openid', 'email'],
  },
  {
    label: 'Gmail',
    sourceUrl: 'https://developers.google.com/identity/protocols/oauth2/scopes#gmail',
    scopes: [
      'gmail.compose',
      'gmail.labels',
      'gmail.metadata',
      'gmail.modify',
      'gmail.readonly',
      'gmail.send',
      'gmail.settings.basic',
    ],
  },
  {
    label: 'Calendar',
    sourceUrl: 'https://developers.google.com/identity/protocols/oauth2/scopes#calendar',
    scopes: [
      'calendar',
      'calendar.calendarlist',
      'calendar.calendarlist.readonly',
      'calendar.events',
      'calendar.events.readonly',
      'calendar.readonly',
    ],
  },
  {
    label: 'Contacts',
    sourceUrl: 'https://developers.google.com/identity/protocols/oauth2/scopes#people',
    scopes: ['contacts.readonly'],
  },
];

export const GOOGLE_OAUTH_SCOPES = GOOGLE_OAUTH_SCOPE_GROUPS.flatMap((group) => group.scopes);
export const GOOGLE_IMPLICIT_OAUTH_SCOPES = ['openid', 'email'];
